export const isDev = true;
export const isStage = true;

export const showBoclipsSearch=false;

export const wordpressURL = isDev
  ? process.env.REACT_APP_STAGING_POLICY_URL
  : process.env.REACT_APP_PRODUCTION_POLICY_URL;

export const amplitudeKey = isDev
  ? process.env.REACT_APP_AMPLITUDE_DEV
  : process.env.REACT_APP_AMPLITUDE_PROD;

export const currentEnv = isDev && !isStage ? "dev-" : isStage ? "staging-" : "";

export const staticsite = "staging.";

export const currentSearchEngine = "Bing";

export const searchEngineOffsets = {
  "Academia": 10,
  "Bing": 21,
  "Books": 9,
  "Wiki": 21,
  "Google": 10,
  "Default": 10,
}

export const searchEngineCounts = {
  "Academia": 10,
  "Bing": 21,
  "Books": 9,
  "Wiki": 21,
  "Google": 10,
  "Default": 10,
};